import * as React from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { ProductInventory } from "components/product/product-inventory";
import type { IFetchOptions, IInventoryMap } from "types/inventory";
import { fetchReplenishments } from "actions/inventory";
import { fetchWarehousesForProduct } from "actions/products";
import * as productActions from "../actions/products/product";
export const WORKING_ORDER_HIDE_INVENTORY_ARRIVING = "WORKING_ORDER/HIDE_INVENTORY_ARRIVING";
import { CircularProgress } from "material-ui";
import * as Immutable from "immutable";
import { $, merge } from "glamor";
import { format } from "lib/globalize-util";
import moment from "moment";
import * as PropTypes from "prop-types";
import ClearIcon from "material-ui/svg-icons/content/clear";
import { rawTheme } from "styles/theme";
import { setViewAs } from "actions/scope";
import me from "models/me";
import _ from "lodash";
import { CompanyRecord } from "records/company";
import get from "lodash/get";
import type { IStore } from "reducers";
import { addLineItem } from "actions/working-order/line-items";
import { IAddLineItemMeta, IAddLineItemPayload } from "types/working-order/line-items";

interface IStateProps {
    originalIndex?: number;
    productId?: string;
    product?: any; // ItemRecord
    companyId?: string;
    warehouseIds: Immutable.Set<string>;
    warehouses: any;
    inventoryMap: IInventoryMap;
    isFetchingReplenishments: boolean;
    scope: any;
    router?: any;
    me: any;
}

interface IActions {
    onSetViewAs: (company) => void;
    onCloseDialog: () => void;
    onFetchProduct: any;
    onFetchReplenishments: (warehouse: string, skus: string[], options?: IFetchOptions) => void;
    onFetchWarehousesForProduct: (productId: string) => void;
    onAddLineItem: (payload: IAddLineItemPayload, meta: IAddLineItemMeta) => void;
}

interface IProps extends IStateProps, IActions {}

interface IState {
    overrideViewAs: boolean;
    warehouseId?: string;
    lastViewAs?: any;
    sessionKey?: string; // session key for fetching replenishments
}

class InventoryArrivingModal extends React.PureComponent<IProps, IState> {
    static contextTypes = {
        app: PropTypes.object.isRequired,
        me: PropTypes.object.isRequired,
    };

    state: IState = { overrideViewAs: false };

    private style = merge(
        $(" .product-info", { display: "flex" }),
        $(" .product-info div", { marginLeft: "16px" }),
        $(" .name", { textTransform: "uppercase", fontWeight: "bold", color: "black" }),
        $(" .progress", { textAlign: "center" }),
        $(" .close-icon", { color: `${rawTheme.palette.grey} !important`, float: "right", cursor: "pointer" }),
        $(" .close-icon:hover", { color: `${rawTheme.palette.primary2Color} !important` }),
        $(" .content", { overflowY: "auto !important" }),
        $(" .arrivalLabel", { position: "relative" }),
        $(" .sizeTable", { overflowY: "hidden" })
    );

    UNSAFE_componentWillMount() {
        window.addEventListener("popstate", this.handleClose);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const currentCompany = nextProps.companyId;
        const open = !!nextProps.productId;
        const warehouse = nextProps.warehouseIds?.first();
        // tslint:disable-next-line:triple-equals
        if (open && currentCompany != get(nextProps.scope, "viewAs._id")) {
            this.setState({
                overrideViewAs: true,
                lastViewAs: nextProps.scope.viewAs,
            });
            const viewAsCompany = currentCompany
                ? new CompanyRecord({
                      _id: currentCompany,
                      __settings: {
                          __warehouses: nextProps.warehouseIds,
                      },
                  })
                : null;
            nextProps.onSetViewAs(viewAsCompany);
            nextProps.onFetchProduct(nextProps.productId);
            nextProps.onFetchWarehousesForProduct(nextProps.productId);
        } else if (open && nextProps.productId !== this.props.productId) {
            const cartScoped = !!window.location?.pathname?.indexOf("/cart");
            nextProps.onFetchProduct(nextProps.productId, false, { forceViewDisabled: cartScoped });
            nextProps.onFetchWarehousesForProduct(nextProps.productId);
            this.setState({ sessionKey: nextProps.productId + Date.now() });
        } else if (open && !nextProps.warehouseIds) {
            nextProps.onFetchWarehousesForProduct(nextProps.productId);
        } else if (open && nextProps.product && warehouse && !this.state.warehouseId) {
            this.setState({ warehouseId: warehouse });
            this.fetchReplenishments(warehouse, nextProps.product);
        }
    }

    handleClose = () => {
        this.setState({ warehouseId: null });
        if (this.state.overrideViewAs) {
            this.props.onSetViewAs(this.state.lastViewAs);
            this.setState({ lastViewAs: null, overrideViewAs: false });
        }
        this.props.onCloseDialog();
    };

    render() {
        const { product, inventoryMap, warehouses, warehouseIds, isFetchingReplenishments, scope } = this.props;
        const productWarehouses = warehouseIds.map((id) => warehouses?.[id]).toArray();

        const isLoading = !product;
        return (
            <Dialog
                title={
                    <div>
                        {format("Inventory Arriving Table")}
                        <ClearIcon className="close-icon" onClick={this.handleClose} />
                    </div>
                }
                bodyClassName="content"
                open={!!this.props.productId}
                className={this.style.toString()}
                onRequestClose={this.props.onCloseDialog}
            >
                {!isLoading && (
                    <div className="product-info">
                        <div>
                            <img src={product.getImageUrl(scope, "T", 0)} />
                        </div>
                        <div className="fields">
                            <span className="name">{product.name}</span>
                            <br />
                            <span>{product.style_number}</span>
                        </div>
                    </div>
                )}
                {isLoading && (
                    <div className="progress">
                        <CircularProgress />
                    </div>
                )}
                {!isLoading && (
                    <ProductInventory
                        product={product}
                        inventoryMap={inventoryMap}
                        isFetching={isFetchingReplenishments}
                        warehouseId={this.state.warehouseId}
                        warehouses={productWarehouses}
                        enforceAvailableUntil={scope.brand.getPreference("enforce_available_until")}
                        showHeader={false}
                        onWarehouseChange={this.handleSetWarehouse}
                        onClickDuplicate={this.handleClickDuplicate}
                        scope={scope}
                    />
                )}
            </Dialog>
        );
    }

    private handleClickDuplicate = (date: moment.Moment) => {
        const { product, onCloseDialog, originalIndex, onAddLineItem } = this.props;
        const { warehouseId } = this.state;
        onAddLineItem(
            { body: { item_id: product._id, warehouse: warehouseId, ship_start: date.format("YYYY/MM/DD") } },
            { notifyCart: true, updateUI: true, originalIndex }
        );
        onCloseDialog();
    };

    private handleSetWarehouse = (e, index: number, warehouseId: string) => {
        const { router } = this.props;

        this.setState({ warehouseId });
        this.fetchReplenishments(warehouseId);
    };

    private fetchReplenishments = (warehouse: string, product = this.props.product) => {
        if (product && warehouse) {
            this.props.onFetchReplenishments(warehouse, _.map(product.__sizes.toJS(), "_id"), {
                session: this.state.sessionKey,
            });
        }
    };
}

function mapStateToProps(state: IStore): IStateProps {
    const { originalIndex, productId, companyId, warehouses } = state.inventoryArriving;
    const product = productId && state.entities.items ? state.entities.items[productId] : null;
    const productWarehouses = state.product.warehouses || Immutable.OrderedSet((product || {}).__warehouse_ids);
    const warehousesToView =
        productWarehouses && (_.isEmpty(warehouses) ? productWarehouses : productWarehouses.intersect(warehouses));
    return {
        originalIndex,
        productId,
        product,
        companyId,
        warehouseIds: warehousesToView,
        warehouses: state.entities.warehouses,
        inventoryMap: state.inventory.replenishments.payload,
        isFetchingReplenishments: state.inventory.replenishments.isFetching,
        scope: state.scope,
        router: state.router,
        me,
    };
}

function mapDispatchToProps(dispatch): IActions {
    return {
        onSetViewAs: (company) => dispatch(setViewAs(company)),
        onFetchWarehousesForProduct: (productId: string) =>
            dispatch(fetchWarehousesForProduct(productId, { populateReplenishments: false })),
        onFetchProduct: (id: string, force: boolean = false, options: any = {}) =>
            dispatch(productActions.fetch(id, force, options)),
        onCloseDialog: () => dispatch({ type: WORKING_ORDER_HIDE_INVENTORY_ARRIVING }),
        onAddLineItem: (payload: IAddLineItemPayload, meta: IAddLineItemMeta) => dispatch(addLineItem(payload, meta)),
        onFetchReplenishments: (warehouse: string, sku: string[], options?: IFetchOptions) =>
            dispatch(fetchReplenishments(warehouse, sku, options)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryArrivingModal);
